import React from 'react';
import styled, { createGlobalStyle } from 'styled-components';
import { GlobalToken, Modal } from 'antd';

import IconPlay from '@/assets/play.svg?react';
import { CustomThemeToken } from '@/theme';

export const EPChartDonutTooltipContainer = styled.div<{ theme: { token: GlobalToken } }>`
  display: flex;
  flex-direction: column;
  font-size: ${({ theme: { token } }) => token.fontSizeSM}px;
  color: ${({ theme: { token } }) => token.colorText};
  background-color: ${({ theme: { token } }) => token.colorBgElevated};
  box-shadow: ${({ theme: { token } }) => token.boxShadowSecondary};
  padding: ${({ theme: { token } }) => token.paddingXS}px;
  border-radius: 4px;

  .value {
    font-weight: ${({ theme: { token } }) => token.fontWeightStrong};
    margin-right: ${({ theme: { token } }) => token.marginXXS}px;
  }
`;

export const EPChartDonutContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  .inner-title {
    font-size: ${({ theme: { token } }) => token.fontSizeXL}px;
    font-weight: ${({ theme: { token } }) => token.fontWeightStrong};
  }

  .bottom-title {
    font-size: ${({ theme: { token } }) => token.fontSize}px;
    font-weight: ${({ theme: { token } }) => token.fontWeightStrong};
  }
`;

export const EPCarouselContainer = styled.div<{ theme: { token: GlobalToken } }>`
  display: flex;
  flex-direction: column;

  .carousel-title {
    font-size: ${({ theme: { token } }) => token.fontSizeSM}px;
    color: ${({ theme: { token } }) => token.colorTextSecondary};
    text-align: center;
  }

  .carousel-image {
    object-fit: contain;
    height: 365px;
    width: 365px;
  }
`;

export const EPTagContainer = styled.div<{ theme: { token: CustomThemeToken } }>`
  background-color: ${({ theme: { token } }) => token.colorBgContainer};
  color: ${({ theme: { token } }) => token.colorAzureText};
  border: 1.2px solid ${({ theme: { token } }) => token.colorPrimaryBorderHover};
  border-radius: 5px;
  padding: 0 ${({ theme: { token } }) => token.paddingXS}px;
  margin-bottom: ${({ theme: { token } }) => token.paddingXXS}px;
`;

export const EPPaginationContainer = styled.div<{ theme: { token: GlobalToken } }>`
  display: flex;
  align-items: center;

  .rotate-right {
    transform: rotate(90deg);
    cursor: pointer;
    width: 10px;
    margin-left: ${({ theme: { token } }) => token.marginXS}px;
  }

  .rotate-left {
    transform: rotate(-90deg);
    cursor: pointer;
    width: 10px;
  }

  .low-opacity {
    opacity: 0.25;
    cursor: default;
  }

  .page {
    font-size: ${({ theme: { token } }) => token.fontSize}px;
    color: ${({ theme: { token } }) => token.colorText};
    cursor: pointer;
    margin-left: ${({ theme: { token } }) => token.marginXS}px;
  }
`;

export const EPLockContainer = styled.div<{ theme: { token: GlobalToken } }>`
  .toggle {
    background-color: ${({ theme: { token } }) => token.colorBgBase};
    border: solid 1px ${({ theme: { token } }) => token.colorPrimary};
    border-radius: 25px;
    position: relative;
    transition: background-color 0.3s;
    display: flex;
    justify-content: center;
    padding-left: ${({ theme: { token } }) => token.paddingXL}px;
    padding-right: ${({ theme: { token } }) => token.paddingXL}px;
    padding-top: ${({ theme: { token } }) => token.paddingXS}px;
    padding-bottom: ${({ theme: { token } }) => token.paddingXS}px;
    align-items: center;
    height: 37px;
  }

  .clickable {
    cursor: pointer;
  }

  .unclickable {
    pointer-events: none;
  }

  .toggle-handle {
    width: 37px;
    height: 37px;
    background-color: ${({ theme: { token } }) => token.colorPrimary};
    border-radius: 50%;
    border: solid 1px ${({ theme: { token } }) => token.colorPrimary};
    position: absolute;
    left: -1px;
    transition: transform 0.3s;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .toggle.on .toggle-handle {
    transform: translateX(0px);
  }
  .label {
    color: ${({ theme: { token } }) => token.colorText};
    font-size: ${({ theme: { token } }) => token.fontSizeSM}px;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    margin-left: ${({ theme: { token } }) => token.margin}px;
  }
  .anticon {
    color: ${({ theme: { token } }) => token.colorText};
    font-size: ${({ theme: { token } }) => token.fontSizeLG}px;
  }
`;

export const InfoIconWrapper = styled.div<{ theme: { token: GlobalToken } }>`
  display: flex;
  align-items: end;
  .anticon {
    color: ${({ theme: { token } }) => token.colorIcon};
    margin-left: ${({ theme: { token } }) => token.marginXXS}px;
  }
`;

export const EPInfoLockContainer = styled.div`
  .border {
    border: 1px solid red;
  }
`;

export const EPRequestTierConfirmationModal = styled(Modal)<{ theme: { token: GlobalToken } }>`
  .ant-modal-content {
    padding-top: 0;
    padding-bottom: 0;
    padding-left: 0;
    background-color: ${({ theme: { token } }) => token.colorBgElevated};
  }

  .request-tier-confirmation-modal {
    display: flex;
    align-items: center;
    color: ${({ theme: { token } }) => token.colorText};

    .mobile-phone {
      margin-bottom: -${({ theme: { token } }) => token.marginXS}px;
      margin-right: ${({ theme: { token } }) => token.marginXXS}px;
    }
  }

  .ant-modal-close {
    color: ${({ theme: { token } }) => token.colorText};
  }
`;

export const EPTierTooltipGlobalStyle = createGlobalStyle<{ theme: { token: GlobalToken } }>`
  .ant-popover.tier-tooltip {
    .tier-tooltip-container {
      display: flex;
      align-items: center;
      font-size: ${({ theme: { token } }) => token.fontSizeSM}px;
    }

    .tier-tooltip-icon-lock {
      margin-left: ${({ theme: { token } }) => token.marginXS}px;
      margin-right: ${({ theme: { token } }) => token.marginMD}px;
      cursor: pointer;
    }

    .tier-tooltip-title {
      font-weight: ${({ theme: { token } }) => token.fontWeightStrong};
    }
  } 
`;

export const EPClickableText = styled.span<{ theme: { token: GlobalToken } }>`
  font-weight: ${({ theme: { token } }) => token.fontWeightStrong};
  text-decoration: underline;
  cursor: pointer;
  color: ${({ theme: { token } }) => token.colorText};
`;

export const EPTierLockCoverContainer = styled.div<{ theme: { token: GlobalToken } }>`
  position: absolute;
  width: 100%;
  height: calc(100% + 5px);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: ${({ theme: { token } }) => token.marginXXS}px;

  .low-opacity-cover {
    opacity: 0.8;
    width: 100%;
    height: calc(100% + 10px);
    background-color: ${({ theme: { token } }) => token.colorBgBase};
    z-index: 3;
    position: absolute;
  }

  .tier-lock {
    z-index: 4;
  }

  .background-data-label {
    color: ${({ theme: { token } }) => token.colorTextSecondary};
    font-weight: ${({ theme: { token } }) => token.fontWeightStrong};
    font-size: ${({ theme: { token } }) => token.fontSizeSM}px;
    position: absolute;
    bottom: 30px;
    z-index: 4;
  }
`;

export const EPTierPaymentPlanCardContainer = styled.div<{ theme: { token: GlobalToken } }>`
  position: absolute;
  margin-left: auto;
  margin-right: auto;
  left: 0;
  right: 0;
  display: flex;
  width: 500px;
  flex-direction: column;
  align-items: center;
  background-color: ${({ theme: { token } }) => token.colorBgContainer};
  font-size: ${({ theme: { token } }) => token.fontSize}px;
  color: ${({ theme: { token } }) => token.colorTextSecondary};
  border: 0.5px solid ${({ theme: { token } }) => token.colorBorder};
  z-index: 3;

  .header {
    background-color: ${({ theme: { token } }) => token.colorBgElevated};
    padding: ${({ theme: { token } }) =>
      `${token.padding}px ${token.paddingLG}px ${token.paddingXS}px ${token.paddingLG}px`};
    display: flex;
    flex-direction: column;
    align-items: center;

    .card-title-container {
      display: flex;
      justify-content: space-between;
      align-items: center;
      align-self: stretch;

      .your-current-version {
        color: ${({ theme: { token } }) => token.colorPrimary};
        font-style: italic;
      }
    }
  }

  .body {
    background-color: ${({ theme: { token } }) => token.colorBgBase};
    width: 100%;
    padding: ${({ theme: { token } }) =>
      `${token.paddingXXS}px ${token.paddingLG}px ${token.paddingXS}px ${token.paddingLG}px`};
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .footer {
    background-color: ${({ theme: { token } }) => token.colorBgElevated};
    width: 100%;
    padding: ${({ theme: { token } }) => `${token.paddingXS}px ${token.paddingLG}px`};
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .card-title {
    font-size: ${({ theme: { token } }) => token.fontSizeXL}px;
    color: ${({ theme: { token } }) => token.colorText};
    font-weight: ${({ theme: { token } }) => token.fontWeightStrong};
    text-transform: uppercase;
    align-self: flex-start;
  }

  .card-description {
    font-size: ${({ theme: { token } }) => token.fontSizeSM}px;
    margin-bottom: ${({ theme: { token } }) => token.marginXXS}px;
  }

  .horizontal-line {
    height: 1px;
    width: 100%;
    background-color: ${({ theme: { token } }) => token.colorBorder};
    margin: ${({ theme: { token } }) => token.marginXXS}px 0 ${({ theme: { token } }) => token.marginXS}px 0;
  }

  .price-per-asset {
    border-radius: 20px;
    border: 0.5px solid ${({ theme: { token } }) => token.colorBorder};
    padding: ${({ theme: { token } }) => `${token.paddingXXS}px ${token.paddingXL}px`};
    font-size: ${({ theme: { token } }) => token.fontSize}px;
    margin-bottom: ${({ theme: { token } }) => token.marginXS}px;
    margin-top: ${({ theme: { token } }) => token.marginXXS}px;

    .price-per-asset-value {
      color: ${({ theme: { token } }) => token.colorPrimary};
      font-weight: ${({ theme: { token } }) => token.fontWeightStrong};
      font-size: ${({ theme: { token } }) => token.fontSizeLG}px;
    }
  }

  .asset-count {
    color: ${({ theme: { token } }) => token.colorPrimary};
    font-weight: ${({ theme: { token } }) => token.fontWeightStrong};
  }

  .monthly-price-container {
    display: flex;
    justify-content: center;
    align-items: baseline;
  }

  .monthly-price-value {
    font-size: ${({ theme: { token } }) => token.fontSizeHeading1}px;
    color: ${({ theme: { token } }) => token.colorText};
    font-weight: ${({ theme: { token } }) => token.fontWeightStrong};
  }

  .monthly-price-period {
    font-size: ${({ theme: { token } }) => token.fontSizeHeading3}px;
  }

  .billed-annually {
    .monthly-price-highlighted {
      font-weight: ${({ theme: { token } }) => token.fontWeightStrong};
      color: ${({ theme: { token } }) => token.colorText};
    }
  }

  .expected-annual-savings-container {
    display: flex;
    align-items: center;
    align-self: stretch;
    margin-bottom: ${({ theme: { token } }) => token.marginXXS}px;

    .expected-annual-savings-label {
      font-size: ${({ theme: { token } }) => token.fontSize}px;
      width: 55%;
      text-align: end;
      padding-right: ${({ theme: { token } }) => token.paddingXL}px;
    }

    .expected-annual-savings-value {
      font-size: ${({ theme: { token } }) => token.fontSizeLG}px;
      color: ${({ theme: { token } }) => token.colorText};
    }
  }

  .expected-roi-container {
    display: flex;
    align-items: center;
    margin-bottom: ${({ theme: { token } }) => token.marginXXS}px;
    align-self: stretch;

    .expected-roi-label {
      font-size: ${({ theme: { token } }) => token.fontSize}px;
      width: 55%;
      text-align: end;
      padding-right: ${({ theme: { token } }) => token.paddingXL}px;
    }

    .expected-roi-chip {
      background-color: ${({ theme: { token } }) => token.colorSuccess};
      padding: 0 ${({ theme: { token } }) => token.paddingXL}px;
      height: 27px;
    }
  }

  .start-one-month-trial-chip {
    background-color: ${({ theme: { token } }) => token.colorSuccess};
    color: ${({ theme: { token } }) => token.colorBgBase};
    text-transform: uppercase;
    padding: ${({ theme: { token } }) => `${token.paddingXXS}px ${token.paddingXL}px`};
    font-weight: ${({ theme: { token } }) => token.fontWeightStrong};
    border-radius: 20px;
    margin-top: ${({ theme: { token } }) => token.marginXXS}px;
    cursor: pointer;
  }

  .or-purchase-now-label {
    color: ${({ theme: { token } }) => token.colorSuccess};
    margin: ${({ theme: { token } }) => token.marginXS}px 0;
    cursor: pointer;
  }

  .feature-title {
    font-weight: ${({ theme: { token } }) => token.fontWeightStrong};
    color: ${({ theme: { token } }) => token.colorText};
    align-self: flex-start;
    margin-bottom: ${({ theme: { token } }) => token.marginXS}px;
  }

  .highlighted-white-text {
    font-weight: ${({ theme: { token } }) => token.fontWeightStrong};
    color: ${({ theme: { token } }) => token.colorText};
  }

  .feature {
    font-size: ${({ theme: { token } }) => token.fontSizeSM}px;
    display: flex;
    width: 100%;
    &:not(:last-child) {
      margin-bottom: ${({ theme: { token } }) => token.marginXXS}px;
    }

    .green-check {
      background-color: ${({ theme: { token } }) => token.colorSuccess};
      border-radius: 10px;
      height: fit-content;
      margin-right: ${({ theme: { token } }) => token.marginXS}px;
      display: flex;
      justify-content: center;
    }
  }

  .get-your-price {
    background-color: ${({ theme: { token } }) => token.colorText};
    border-radius: 30px;
    font-size: ${({ theme: { token } }) => token.fontSizeXL}px;
    color: ${({ theme: { token } }) => token.colorBgBase};
    font-weight: ${({ theme: { token } }) => token.fontWeightStrong};
    margin: ${({ theme: { token } }) => token.marginSM}px 0;
    padding: ${({ theme: { token } }) => `${token.paddingXXS}px ${token.paddingXL}px`};
  }
`;

interface EPSystemControlPaymentPlanCardContainerProps {
  $fromOfferingPage?: boolean;
  theme: { token: GlobalToken };
}

export const EPSystemControlPaymentPlanCardContainer = styled.div<EPSystemControlPaymentPlanCardContainerProps>`
  padding: ${({ $fromOfferingPage, theme: { token } }) =>
    $fromOfferingPage ? `${token.paddingMD}px 0` : `${token.paddingXL}px ${token.paddingLG}px`};
  position: absolute;
  top: 75%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: ${({ $fromOfferingPage, theme: { token } }) =>
    $fromOfferingPage ? 'transparent' : token.colorBgContainer};
  width: ${({ $fromOfferingPage }) => ($fromOfferingPage ? '1050px' : '1116px')};
  z-index: 2;
  @media (max-width: 1146px) {
    padding-top: ${({ $fromOfferingPage }) => ($fromOfferingPage ? null : '760px')};
    width: 600px;
  }

  .dashed-border-container {
    border: 2px dashed ${({ theme: { token } }) => token.colorPrimary};
    position: relative;
    padding: ${({ $fromOfferingPage, theme: { token } }) =>
      $fromOfferingPage
        ? `${token.paddingLG}px ${token.paddingXS}px ${token.paddingXS}px ${token.paddingXS}px`
        : `${token.paddingXL}px ${token.padding}px`};
    display: flex;
    flex-direction: column;
    gap: 10px;
    @media (min-width: 1146px) {
      flex-direction: row;
      gap: 0px;
    }
    & > * {
      position: relative;
      left: 0;
      right: 0;
      &:last-child {
        ${({ $fromOfferingPage }) => $fromOfferingPage && 'min-height: 723px'};
      }

      .header,
      .footer {
        background-color: ${({ theme: { token } }) => token.colorBgContainer};
      }

      .card-description {
        min-height: 75px;
      }
    }

    .system-control-title-chip {
      background-color: ${({ theme: { token } }) => token.colorPrimary};
      border-radius: 8px;
      text-transform: uppercase;
      color: ${({ theme: { token } }) => token.colorBgBase};
      font-weight: ${({ theme: { token } }) => token.fontWeightStrong};
      font-size: ${({ theme: { token } }) => token.fontSizeXL}px;
      padding: ${({ theme: { token } }) => `${token.paddingXXS}px ${token.paddingXL}px`};
      position: absolute;
      left: 50%;
      transform: translate(-50%, -50%);
      top: -2px;
      width: fit-content;
      white-space: nowrap;
    }
  }

  .hidden {
    visibility: hidden;
  }
`;

export const NoStationAvailable = styled.span`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const StyledIconPlay = styled(props => <IconPlay {...props} />)`
  padding-left: ${({ theme: { token } }) => token.paddingXXS}px;
`;
